import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { FaTimes, FaSave, FaCheckCircle, FaSpinner } from 'react-icons/fa';
import { ui } from '../utils/styles';

const BaixaParcelaModal = ({ show, onClose, parcela, onBaixa }) => {

    const [valorRecebido, setValorRecebido] = useState(0);
    const [dataPagamento, setDataPagamento] = useState(new Date().toISOString().split('T')[0]);
    const [loading, setLoading] = useState(false);

    const URL_BACKEND = process.env.REACT_APP_URL_BACKEND;
    const authHeader = { Authorization: `Bearer ${localStorage.getItem('userToken')}` };

    // --- Efeitos de Inicialização ---
    useEffect(() => {
        if (show && parcela) {
            setValorRecebido(Number(parcela.valor || 0));
            setDataPagamento(new Date().toISOString().split('T')[0]);
        }
    }, [show, parcela]);

    // --- Lógica de Baixa ---
    const handleSave = async (e) => {
        e.preventDefault();

        if (!valorRecebido || valorRecebido <= 0 || !dataPagamento) {
            toast.error('Preencha o valor e a data de pagamento.');
            return;
        }

        const payload = {
            status: 'Pago',
            valor_recebido: valorRecebido,
            data_pagamento: dataPagamento,
            // Adicione aqui campos como multa/juros se necessário.
        };

        setLoading(true);
        const toastId = toast.loading(`Registrando pagamento da Parcela #${parcela.id}...`);

        try {
            // Endpoint de atualização da parcela para dar baixa
            await axios.put(`${URL_BACKEND}/parcela/${parcela.id}`, payload, { headers: authHeader });

            toast.success('Baixa de parcela registrada com sucesso!', { id: toastId });
            onBaixa(); // Recarrega a lista
            onClose();
        } catch (error) {
            console.error('Erro ao dar baixa na parcela:', error);
            const msg = error.response?.data?.message || 'Erro ao registrar pagamento.';
            toast.error(msg, { id: toastId });
        } finally {
            setLoading(false);
        }
    };

    if (!show || !parcela) return null;

    const formatCurrencyDisplay = (value) => {
        return `R$ ${Number(value).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
    };

    return (
        <div style={ui.modalOverlay}>
            <div style={ui.modalContent}>

                {/* Cabeçalho do Modal */}
                <div style={ui.modalHeader}>
                    <h2 style={ui.modalTitle}>
                        <FaCheckCircle style={{ marginRight: 8, color: '#059669' }} /> Registrar Pagamento (Baixa)
                    </h2>
                    <button onClick={onClose} style={ui.modalCloseButton} disabled={loading}>
                        <FaTimes />
                    </button>
                </div>

                <form onSubmit={handleSave} style={ui.modalBody}>
                    <p style={{ marginBottom: 16, fontSize: '1rem', color: '#1f2937' }}>
                        Confirmar recebimento da **Parcela #{parcela.numero}** (Vencimento: {new Date(parcela.data_vencimento).toLocaleDateString('pt-BR')}) no valor de **{formatCurrencyDisplay(parcela.valor)}**
                    </p>

                    <div style={ui.formGrid}>

                        {/* 1. Valor Recebido */}
                        <div style={ui.formGroup}>
                            <label style={ui.label} htmlFor="valorRecebido">Valor Recebido *</label>
                            <input
                                id="valorRecebido"
                                type="number"
                                step="0.01"
                                style={ui.input}
                                value={valorRecebido}
                                onChange={e => setValorRecebido(Number(e.target.value))}
                                disabled={loading}
                                required
                            />
                        </div>

                        {/* 2. Data de Pagamento */}
                        <div style={ui.formGroup}>
                            <label style={ui.label} htmlFor="dataPagamento">Data de Pagamento *</label>
                            <input
                                id="dataPagamento"
                                type="date"
                                style={ui.input}
                                value={dataPagamento}
                                onChange={e => setDataPagamento(e.target.value)}
                                disabled={loading}
                                required
                            />
                        </div>

                    </div>

                    {/* Rodapé do Modal (Ações) */}
                    <div style={ui.modalFooter}>
                        <button
                            type="button"
                            onClick={onClose}
                            style={ui.buttonLight}
                            disabled={loading}
                        >
                            Cancelar
                        </button>

                        <button
                            type="submit"
                            style={{ ...ui.buttonPrimary, background: '#059669' }}
                            disabled={loading}
                        >
                            {loading ? <FaSpinner className="fa-spin" /> : <FaSave />}
                            Confirmar Baixa
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default BaixaParcelaModal;